import { observer } from 'mobx-react';
import * as style from './DealScoreCard.module.less';
import classNames from 'classnames';

interface IDealScoreCardProps {
    score: number | string;
    className?: string;
}

export const DealScoreCard = observer((p: IDealScoreCardProps) => {
    var icon = 'bi bi-check';
    var text = 'Strong';
    var color = '#00A171';

    var score: number = parseInt(p.score.toString());
    var scoreDisplay = score.toString();

    if (score > 85) {
        // Strong - defaults
    } else if (p.score == -1) {
        icon = 'bi bi-dash';
        text = 'No Data';
        color = '#6C757D';
        scoreDisplay = '--';
    } else if (score > 55) {
        // Medium
        icon = 'bi bi-dash';
        text = 'Medium';
        color = '#FF9F00';
    } else {
        // Weak
        icon = 'bi bi-x';
        text = 'Weak';
        color = '#DD2222';
    }

    // Check if we should show dots instead of score
    const shouldShowDots = p.score == -1 || isNaN(score);
    const finalScoreDisplay = shouldShowDots ? '...' : scoreDisplay;

    var iconCls = classNames('bi', icon, style.icon);

    return (
        <div className={classNames(style.scoreCard, p.className)}>
            <i className={iconCls} style={{ color: color }}></i>
            <div className={style.scoreText}>
                <span className={style.scoreNumber} style={{ color: color }}>
                    {finalScoreDisplay}
                </span>
                <span className={style.scoreLabel} style={{ color: color }}>
                    {text}
                </span>
            </div>
        </div>
    );
});
